<template>
  <div class="gaoya">
    <div class="total">
      <div class="top">
        <div class="left">
          <div class="item">
            <span>回路总数：</span>
            <span class="color1">{{ equipmentNumber.totalCount }}</span>
          </div>
          <div class="item">
            <span>正常：</span>
            <span class="color1">{{ equipmentNumber.normalCount }}</span>
          </div>
          <div class="item">
            <span>异常：</span>
            <span class="color2">{{ equipmentNumber.abnormalCount }}</span>
          </div>
        </div>
        <div class="right">
          <el-input placeholder="请输入现场编号" prefix-icon="el-icon-search" clearable v-model="input2">
          </el-input>
          <el-button type="primary" @click="searchInfo">搜索</el-button>
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="item" :class="stateIndex == index ? 'active' : ''" v-for="(item, index) in states" :key="index"
            @click="stateIndex = index">
            {{ item }}
          </div>
        </div>
        <!-- <div class="right">
          <span>开关量状态：</span>
          <i class="color1"></i>
          <span>分闸</span>
          <i class="color2"></i>
          <span>合闸</span>
        </div> -->
      </div>
    </div>
    <div class="main-info">
      <section>
        <div class="card-box">
          <!-- @click="showLineChart(item)" -->
          <div class="card" v-for="(item, index) in equipmentList" :key="index" @click="showLineChart(item)">
            <div class="top">
              <div class="ctitle">
                <div class="left">
                  <img src="../../../assets/images/wenshidu.png" alt="" />
                  <p>{{ item.localeNumber }}</p>
                </div>
                <div class="right">
                  <!-- <el-switch
                    v-model="item.status2"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch> -->
                  <!-- <myswitch :type="item.equipmentStatus"></myswitch> -->
                </div>
              </div>
              <div class="info">{{ item.equipmentDesc }}</div>
            </div>
            <div class="br"></div>
            <div class="bottom">
              <div class="item">
                <span>温度：</span>
                <span>{{ item.humitureList[0].value | getTwo }}℃</span>
              </div>
              <div class="item">
                <span>湿度：</span>
                <span>{{ item.humitureList[1].value | getTwo }}%</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog title="温湿度变化" :visible.sync="dialogVisible" width="70%" height="80%" destroy-on-close>
      <div v-loading="dialogLoading">
        <div class="section2">
          <div class="item1">
            <layout1 :title="'历史数据查询'">
              <div class="box">
                <div class="data-download">
                  <div class="block">
                    <span class="demonstration">日期：</span>
                    <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd"
                      @change="searchMonitorByEquipmentAndType()" :picker-options="expireTimeOption" placeholder="选择日期">
                    </el-date-picker>
                  </div>
                  <!-- <img @click="download" v-if="hasData2" src="../../../assets/images/download.png" /> -->
                </div>
                <div class="change-box">
                  <div class="item" :class="changeIndex == 0 ? 'active' : ''" @click="changeIndexChange(0)">
                    图表
                  </div>
                  <div class="item" :class="changeIndex == 1 ? 'active' : ''" @click="changeIndexChange(1)">
                    数据
                  </div>
                </div>
                <div class="table">
                  <div class="swtich" v-if="changeIndex == 0">
                    <el-tabs v-model="smallType" @tab-click="smallTypeChange">
                      <el-tab-pane v-for="(item, index) in changeLabelList" :key="index" :label="item.label"
                        :name="item.smallType"></el-tab-pane>
                    </el-tabs>
                  </div>
                  <v-chart v-if="changeIndex == 0 && hasData2" :option="option" ref="chart"></v-chart>
                  <div class="show-date" v-if="changeIndex == 1">日期：{{showTime}}</div>
                  <div class="table-box" v-if="changeIndex == 1">
                    <el-table :data="tableData1" border style="width: 99%" height="420">

                      <el-table-column prop="time" label="时间" width="120">
                      </el-table-column>
                      <el-table-column label="温度(°C)">
                        <el-table-column prop="T1" label="最低" width="120">
                        </el-table-column>
                        <el-table-column prop="T2" label="最高" width="120">
                        </el-table-column>
                        <el-table-column prop="T" label="平均" width="120">
                        </el-table-column>

                      </el-table-column>
                      <el-table-column label="湿度(%)">
                        <el-table-column prop="H1" label="最低" width="120">
                        </el-table-column>
                        <el-table-column prop="H2" label="最高" width="120">
                        </el-table-column>
                        <el-table-column prop="H" label="平均" width="120">
                        </el-table-column>
                      </el-table-column>

                    </el-table>
                  </div>
                </div>
              </div>
              <div class="image-box" v-if="!hasData2 && changeIndex == 0">
                <img src="../../../assets/images/nodata1.png" alt="" />
              </div>
            </layout1>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ECharts from "vue-echarts";
  export default {
    components: { "v-chart": ECharts },
    data () {
      return {
        tableData1: [],
        selItem: {},
        hasData2: true,
        labelList: [],
        changeIndex: 0, // 0图表,1:表格
        expireTimeOption: {
          disabledDate (date) {
            return date.getTime() > Date.now();
          },
        },
        input2: "",
        dialogLoading: false,
        nodata: false,
        states: ["全部", "正常", "异常"],
        stateIndex: 0,
        switchValue: true,
        equipmentNumber: {},
        equipmentList: [],
        dialogVisible: false,
        option: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985",
                formatter: function (p) {
                  if (p.axisIndex == 1) {
                    return "";
                  }
                  let str = p.seriesData[0].data[0];
                  let str2 = "";
                  p.seriesData.forEach((i) => {
                    str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                  });
                  return str + str2;
                },
              },
            },
          },
          legend: {
            right: "5%",
            top: "4%",
            data: ["A相电压", "B相电压", "C相电压"],
          },
          color: [
            "rgba(0, 191, 113, 1)",
            "rgba(251, 199, 2, 1)",
            "rgba(20, 108, 224, 1)",
          ],
          grid: {
            left: "1%",
            right: "4%",
            bottom: "3%",
            top: "10%",
            containLabel: true,
          },
          xAxis: [{
            show: false,
            position: "top",
            type: "time",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
              // padding: [0, -10, 0, 35],    // 四个数字分别为上右下左与原位置距离
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
          },
          {
            show: true,
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              // padding: [0, 0, 0, -40],    // 四个数字分别为上右下左与原位置距离
              fontSize: 12,
            },
            offset: 2,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            position: "bottom",
            axisPointer: {
              type: "none",
            },
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
              "7时",
              "8时",
              "9时",
              "10时",
              "11时",
              "12时",
              "13时",
              "14时",
              "15时",
              "16时",
              "17时",
              "18时",
              "19时",
              "20时",
              "21时",
              "22时",
              "23时",
              "24时",
            ],
          },
          ],
          yAxis: {
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
          },
          series: [{
            name: "A相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          {
            name: "B相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          {
            name: "C相电压",
            type: "line",
            symbolSize: 0,
            lineStyle: {
              width: 4,
            },
            data: [],
          },
          ],
        },
        topicList: [],
        date: "",
      };
    },
    computed: {
      roomId () {
        return this.$store.state.roomId;
      },
      changeLabelList () {
        let arr = [];
        this.labelList.forEach((i) => {
          let obj = {
            label: i.groupName,
            smallType: i.smallType,
          };
          arr.push(obj);
        });
        return arr;
      },
    },
    watch: {
      roomId (v) {
        this.searchEquipmentStatusByType();
        this.searchHumitureMonitors();
      },
      stateIndex (n) {
        this.searchHumitureMonitors(n);
      },
      input2 (v) {
        if (!v) {
          this.searchHumitureMonitors();
          this.searchEquipmentStatusByType();
        }
      },
    },
    created () {
      this.searchEquipmentStatusByType();
      this.searchHumitureMonitors();
      this.date = this.$dateFormat("YYYY-mm-dd", new Date());
    },
    methods: {
      changeIndexChange (i) {
        this.changeIndex = i
        if (this.changeIndex == 0) {
          this.searchMonitorByEquipmentAndType();
        } else {
          this.searchMonitorTable()
        }
      },

      searchMonitorTable () {
        const projectId = this.$getCookie("projectId");
        this.$http
          .post(
            "bma-distribution-service/realTimeMonitoring/searchMonitorTable", {
            equipmentCode: this.selItem.equipmentCode,
            projectId: projectId,
            date: this.date,
          }
          )
          .then((res) => {
            // 12A电流 13B 14C  17三相电流不平衡率（百分比）
            // 1A 电压 2B 3C    35 三相总有功电度  6三相电压不平衡度
            // 22无用功率  18 有用功率 90/300 负载率
            // 07 AB线电压  08 BC线电压  09 CA线电压
            // 7 8 9 11  12 13 14 17 18 22  calculatePower
            let newData = res.data;
            let newArr = [];
            if (newData && newData.length > 0) {
              newData.forEach((item) => {
                let obj = {};
                for (let key in item.dataMap) {
                  // console.log(key + '---' + item.dataMap[key])
                  item.dataMap[key] = item.dataMap[key] ?
                    Math.floor(item.dataMap[key] * 100) / 100 :
                    "";
                }
                Object.assign(obj, item, item.dataMap);
                delete obj.dataMap;
                newArr.push(obj);
              });
              this.tableData1 = newArr;
            }
          });
      },
      smallTypeChange (st) {

        this.smallType = st.name
        this.searchMonitorByEquipmentAndType();
      },
      showLineChart (e) {
        this.dialogLoading = true;
        this.dialogVisible = true;
        this.changeIndex = 0
        this.date = this.$dateFormat("YYYY-mm-dd", new Date());
        if (e) {
          this.selItem = e
        }
        this.$http
          .post(
            "bma-distribution-service/filedGroups/searchFiledNameByEquipment", {
            equipmentType: 5,
            groupType: 2,
          }
          )
          .then((res) => {
            this.labelList = res.data;
            if (res.data.length > 0) {
              this.smallType = res.data[0].smallType;
              this.searchMonitorByEquipmentAndType();
            }
          });
      },
      // 设备数量及状态统计
      searchEquipmentStatusByType () {
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post(
              "bma-distribution-service/realTimeMonitoring/searchEquipmentStatusByType",
              {
                equipmentType: 8,
                localeNumber: this.input2,
                roomId: this.roomId,
              }
            )
            .then((res) => {
              this.equipmentNumber = res.data;
            });
        }
      },
      searchInfo () {
        this.searchHumitureMonitors();
        this.searchEquipmentStatusByType();
      },
      // 查询列表
      searchHumitureMonitors (n) {
        let equipmentStatus = null;
        if (n == 1) {
          equipmentStatus = 1;
        } else if (n == 2) {
          equipmentStatus = 0;
        }
        // const roomId = this.$getCookie("roomId");
        if (!this.roomId) {
          return false;
        } else {
          this.$http
            .post("bma-distribution-service/realTime/searchHumitureMonitors", {
              roomId: this.roomId,
              localeNumber: this.input2,
              equipmentStatus: equipmentStatus,
            })
            .then((res) => {
              if (res.data) {
                res.data.forEach((item) => {
                  item.status2 = !!item.status;
                  // 实时
                  item.humitureList.forEach((j) => {
                    if (this.topicList.indexOf(j.subscribeField) == -1) {
                      this.topicList.push(j.subscribeField);
                    }
                    this.$timeing(j.subscribeField, j.subscribeField, (res) => {
                      const body = JSON.parse(res.body);
                      this.equipmentList.forEach((i) => {
                        i.humitureList.forEach((j) => {
                          if (j.subscribeField.indexOf(body.field) > -1) {
                            j.value = body.value;
                          }
                        });
                      });
                    });
                  });
                });
                this.equipmentList = res.data;
              }
            });
        }
      },
      // 显示折线图
      searchMonitorByEquipmentAndType () {

        const projectId = this.$getCookie("projectId");
        this.hasData2 = true;
        this.$http
          .post(
            "bma-distribution-service/realTime/searchMonitorByEquipmentAndType", {
            chartDataType: this.smallType,
            date: this.date,
            equipmentCode: this.selItem.equipmentCode,
            projectId: projectId,
          }
          )
          .then((res) => {
            // 清空表格
            if (this.$refs.chart) {
              this.$refs.chart.clear();
            }
            let legend = [];
            let series = [];
            let maxLine = "";
            if (res.data) {
              if (res.data.length == 0) {
                this.hasData2 = false;
                return;
              }
              let allNum = [];
              res.data.forEach((item) => {
                legend.push(item.subscribeFieldName);
                let arr = [];
                let Nums = [];
                // + 86400000
                item.dataList.forEach((j) => {
                  if (
                    j.date ===
                    this.$dateFormat("YYYY-mm-dd", new Date(this.date)) +
                    " 00:00:00" &&
                    j.value === ""
                  ) {
                    return false;
                  } else {
                    arr.push([j.date, this.$getTwo(j.value)]);
                    Nums.push(Math.abs(j.value));
                  }
                });
                allNum.push(Math.max(...Nums))
                // let dateEnd = new Date(this.date).getTime();
                // arr.push([
                //   this.$dateFormat("YYYY-mm-dd", new Date(dateEnd)) + " 23:00:00",
                //   "",
                // ]);
                let dateEnd = new Date(this.date).getTime() + 86400000;
                arr.push([
                  this.$dateFormat("YYYY-mm-dd", new Date(dateEnd)) + " 00:00:00",
                  "",
                ]);
                maxLine = (parseInt(Math.max(...allNum) * 2) === 0 ? parseInt(Math.max(...allNum)) : parseInt(Math.max(...allNum) * 2));
                let obj = {
                  name: item.subscribeFieldName,
                  field: item.subscribeField,
                  type: this.smallType === 7 ? "bar" : "line",
                  symbolSize: 0,
                  lineStyle: this.smallType === 7 ?
                    '' : {
                      width: 4,
                    },
                  data: this.smallType === 7 ? arr.splice(0, 24) : arr,
                };
                series.push(obj);
              });
              console.log('++++++++++++++++++++++')
              console.log(legend)
              this.option.legend.data = legend;
              // 电量特殊处理
              this.option.tooltip.axisPointer.type = this.smallType === 7 ? 'none' : 'line';
              this.option.tooltip.axisPointer.label.formatter = this.smallType === 7 ? function (p) {
                if (p.axisIndex == 1) {
                  return "";
                }
                console.log('-----------------------')
                console.log(p)
                let str = Number((p.seriesData[0].data[0]).slice(10, 13)) + '时';
                let str2 = "";
                p.seriesData.forEach((i) => {
                  str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                });
                return str + str2;
              } : function (p) {
                if (p.axisIndex == 1) {
                  return "";
                }
                let str = p.seriesData[0].data[0];
                let str2 = "";
                p.seriesData.forEach((i) => {
                  str2 + "<br/>" + i.seriesName + ": " + i.data[1];
                });
                return str + str2;
              },
                this.option.series = series;
              this.option.yAxis.max = maxLine;
              // this.option.series[0].data = this.option.series[0].data.map((x, i) => [300 + i * 100, x]);//30为偏移量
              this.dialogLoading = false;
            }
            // if (this.$dateFormat("YYYY-mm-dd", new Date()) == this.date) {
            //   // this.setStomp(res.data);
            // } else {
            //   this.topicList2.forEach((item) => {
            //     this.$clearTimeing(item);
            //   });
            // }
          });
      },
    },
    beforeDestroy () {
      this.topicList.forEach((item) => {
        this.$clearTimeing(item);
      });
    },
  };
</script>

<style lang="less" scoped>
  .image-box {
    height: 100%;
    width: 100%;

    img {
      height: 40%;
      margin: 10% 38% 2%;
    }

    .nodata-txt {
      margin-left: 47%;
      font-size: 20px;
    }
  }

  .gaoya {
    margin-top: -15px;

    .total {
      width: 100%;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;

          .item {
            border: 1px solid #eaedef;
            border-radius: 21px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            padding: 0 27px;
            margin-right: 37px;

            span {
              font-weight: 600;

              &.color1 {
                color: rgba(20, 96, 224, 1);
              }

              &.color2 {
                color: rgba(224, 20, 20, 1);
              }
            }
          }
        }

        .right {
          display: flex;

          .el-input {
            margin-right: 10px;
          }
        }
      }

      .bottom {
        margin-top: 30px;
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        .left {
          display: flex;

          .item {
            margin-right: 30px;
            font-size: 16px;
            position: relative;
            padding-bottom: 15px;
            cursor: pointer;

            &.active {
              font-weight: 600;
              border-bottom: 3px solid rgba(20, 96, 224, 1);
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #0e223d;

          i {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin: 0 15px;

            &.color1 {
              background: rgba(61, 224, 159, 1);
            }

            &.color2 {
              background: rgba(248, 113, 113, 1);
            }
          }
        }
      }
    }

    .main-info {
      padding: 15px;

      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 9px 18px;
        background: #fff;
        border-radius: 7px;
        width: 106px;
        line-height: 40px;
        height: 40px;
        background: #ffffff;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
        margin-bottom: 15px;

        .icon-box {
          width: 15px;
          height: 15px;
          background: rgba(20, 96, 224, 1);
          text-align: center;
          line-height: 15px;
          margin-right: 5px;

          i {
            color: #fff;
          }
        }

        p {
          font-weight: 600;
        }
      }

      .card-box {
        display: flex;
        flex-wrap: wrap;

        .card {
          width: 381px;
          height: 170px;
          background: #ffffff;
          box-shadow: 0px 3px 6px rgba(40, 76, 122, 0.1);
          opacity: 1;
          border-radius: 8px;
          cursor: pointer;
          margin-right: 36px;
          margin-bottom: 20px;

          &:nth-of-type(4n) {
            margin-right: 0;
          }

          .top {
            padding: 9px 20px;
            border-bottom: 1px solid #e9e9e9;

            .ctitle {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .left {
                display: flex;
                align-items: center;

                img {
                  width: 42px;
                  margin-right: 7px;
                }

                p {
                  font-weight: 600;
                }
              }
            }

            .info {
              color: #7d7d7d;
              line-height: 22px;
              font-size: 18px;
              font-weight: 600;
              margin-top: 10px;
              height: 45px;
            }
          }

          .br {
            width: 104px;
            height: 1px;
            background: #1460e0;
            margin-top: -1px;
          }

          .bottom {
            display: flex;
            cursor: pointer;

            .item {
              width: 50%;
              text-align: center;
              line-height: 56px;

              span {
                font-weight: 600;

                &:last-of-type {
                  color: rgba(245, 167, 50, 1);
                }
              }

              &:last-of-type {
                span {
                  &:last-of-type {
                    color: rgba(20, 96, 224, 1);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  /deep/.el-dialog {
    .el-dialog__body {
      padding: 0 20px;
    }

    .title {
      font-size: 26px;
      font-weight: 500;
      line-height: 44px;
      color: #152139;
      opacity: 1;
    }

    .chart-box {
      width: 100%;
      height: 35vw;
      padding-bottom: 30px;
    }
  }


  .section2 {
    margin-top: 20px;
    padding-left: 10px;
    padding-bottom: 20px;

    .item1 {
      // width: 1640px;
      width: calc(100% - 10px);
      height: 640px;
      position: relative;

      .image-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 210px;
        left: 580px;

        img {
          width: 400px;
        }
      }

      .data-download {
        position: absolute;
        right: 20px;
        top: 15px;
        display: flex;
        font-size: 14px;

        img {
          margin-left: 30px;
          width: 40px;
          cursor: pointer;
        }
      }

      .swtich {
        height: 30px;
        margin-top: 30px;
        /* position: absolute; */
        z-index: 20;

        .item {
          float: left;
          color: #0e223d;
          font-size: 14px;
          position: relative;
          margin-right: 20px;
          cursor: pointer;

          &.active {
            font-weight: 600;

            &::after {
              content: "";
              position: absolute;
              bottom: -14px;
              left: 0;
              right: 0;
              height: 3px;
              background: #1460e0;
            }
          }
        }
      }

      .change-box {
        display: flex;
        height: 30px;
        margin-top: 30px;
        /* position: absolute; */
        top: 0;
        left: 180px;

        .item {
          width: 100px;
          height: 28px;
          border-radius: 16px;
          line-height: 28px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;

          &.active {
            background: rgba(20, 96, 224, 0.1);
            color: rgba(20, 96, 224, 1);
          }
        }
      }

      .table {
        width: 80%;
        height: 450px;
        /* margin-top: 132px; */
        border-top: 1px solid #eeeeef;
        position: relative;

        .table-box {
          padding-top: 60px;
          box-sizing: border-box;

          /deep/.el-table {
            background: rgba(0, 0, 0, 0);

            th,
            tr {
              background: rgba(0, 0, 0, 0);
            }

            thead {
              background: #f5f5f5 !important;
            }

            th {
              >.cell {
                color: #152139;
                font-size: 14px;
                font-weight: 600;
                text-align: center;
              }
            }

            tr {
              td {
                text-align: center;
                font-size: 14px;
                color: #152139;
              }
            }
          }
        }
      }
    }
  }
</style>